/** @param {string} machineId */
export const connect = machineId => {
	window.open(`phaze://connect?id=${machineId}`, "_blank");
};
